import { DEFAULT_LANGUAGE } from '@cibli/shared';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import { useLanguageContext } from '@/features/common/contexts/language.context';
import { useUserContext } from '@/features/common/contexts/user.context';
import LanguageSelectorScreen from '@/features/language/pages/LanguageSelectorScreen';
import { useBooth } from '@/features/settings/hooks/useBooth';

export default function LanguagePage() {
  const navigate = useNavigate();
  const { onReset } = useInterviewContext();
  const { setLanguage } = useLanguageContext();
  const { user } = useUserContext();
  const { booth, loading: boothLoading, isBoothDefaultLocaleEnabled } = useBooth();

  // D1: interface préchoisie → skip the language page entirely.
  // D2 priority: account locale > booth default > global default.
  const shouldSkip = isBoothDefaultLocaleEnabled && !!booth?.interfacePreselected;

  useEffect(() => {
    if (!shouldSkip) return;
    const locale = user?.localeId ?? booth?.defaultLocaleId ?? DEFAULT_LANGUAGE;
    void setLanguage(locale).then(() => navigate('/onboarding', { replace: true }));
  }, [shouldSkip, user?.localeId, booth?.defaultLocaleId, setLanguage, navigate]);

  const handleLanguageSelected = useCallback(() => {
    navigate('/onboarding', { replace: true });
  }, [navigate]);

  // Avoid flashing the selector while the booth config decides to skip it
  if (isBoothDefaultLocaleEnabled && (boothLoading || shouldSkip)) {
    return null;
  }

  return <LanguageSelectorScreen onLanguageSelected={handleLanguageSelected} onCancel={onReset} />;
}
